export default {
  "pl": {
    "editor_ziggu": {
      "actions": {
        "showLess": "Pokaż mniej",
        "showMore": "Pokaż więcej"
      },
      "placeholders": {
        "content": "Zacznij pisać…",
        "link": "Wprowadź lub wklej odnośnik"
      }
    }
  }
}
